/* eslint-disable default-param-last */
import { SET_USER_INFO, SET_SHOW_POPUP } from "../actions/types";
const initState = {
    name: "",
    email: "",
    has_subscription: true,
    gainful_member_since: 2023,
    banner_data: { copy: "", code: "" },
    profile_id: "",
    summary_text: "",
    is_influencer: false,
    cancelled_less_two_days: false,
    rd_check_in_completed: false,
    full_name: "",
    showPopup: false,
    showFutureOrderToggles: false,
    gender: "",
};
export default function profileUserReducer(state = initState, action) {
    switch (action.type) {
        case SET_USER_INFO: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case SET_SHOW_POPUP: {
            return {
                ...state,
                showPopup: action.payload
            };
        }
        default:
            return state;
    }
}
